angular
  .module('ui-ng-university-branding')
  .constant('universityBrandingDelegateConfiguration', {
    uniqueComponent: 'university-branding',
    vocabulary: {
      read: function (event) {
        this.read();
      },
      update: function (scope, element, attrs, event, config, defaultConfig) {
        this.updateColors(config, defaultConfig);
      }
    }
  })
  .service(
    'universityBrandingDelegate',
    function universityBrandingDelegate(DelegateController, universityBrandingDelegateConfiguration) {
      DelegateController(this, universityBrandingDelegateConfiguration);
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-university-branding/src/lib/university_branding_delegate.es.js